export default __webpack_public_path__ + "14408ab95621e4d0e636104c0d045106.png";